import { Weekday } from './types';

const WEEKDAY_BY_UTC_DAY: ReadonlyArray<Weekday> = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

/**
 * Zero padding is not cosmetic here: ranges are compared as strings, so `2026-6-1` would sort
 * after `2026-06-30`.
 */
function isCanonicalIsoDate(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

/** Parses at UTC midnight so a browser timezone can never move a surcharge onto an adjacent day. */
export function parseIsoDateUtc(isoDate: string): Date | null {
  if (!isCanonicalIsoDate(isoDate)) {
    return null;
  }
  const [year, month, day] = isoDate.split('-').map(Number);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  // Date.UTC silently rolls out-of-range parts over (month 13 becomes January), so require a full
  // round-trip rather than pricing a date the CM never typed.
  const roundTrips =
    parsed.getUTCFullYear() === year && parsed.getUTCMonth() === month - 1 && parsed.getUTCDate() === day;
  return roundTrips ? parsed : null;
}

export function weekdayOf(isoDate: string): Weekday | null {
  const parsed = parseIsoDateUtc(isoDate);
  return parsed == null ? null : WEEKDAY_BY_UTC_DAY[parsed.getUTCDay()];
}
